<template>
  <Modal
    v-model="visible"
    :title="title"
    fullscreen
  >
    <template v-slot:footer>
      <Button type="text" :disabled="index === 0" @click="handlePre">上一张</Button>
      <span class="page">{{ `${index + 1} / ${list.length}` }}</span>
      <Button type="text" :disabled="index + 1 === list.length" @click="handleNext">下一张</Button>
      <Button type="error" @click="handleDel">删除</Button>
    </template>
    <img v-if="item" class="image" :src="item.response">
  </Modal>
</template>

<script>
export default {
  name: 'image-view',
  props: {
    list: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      visible: false,
      index: -1
    }
  },
  computed: {
    item () {
      return this.list[this.index]
    }
  },
  methods: {
    open (index) {
      this.visible = true
      this.index = index
    },
    handleDel () {
      this.$emit('on-image-remove', this.index)
      if (!this.list[this.index]) {
        this.index--
        if (!this.list[this.index]) {
          this.visible = false
        }
      }
    },
    handlePre () {
      this.index--
    },
    handleNext () {
      this.index++
    }
  }
}
</script>

<style lang="scss" scoped>
.image {
  display: block;
  width: 100%;
}
.page {
  margin: 0 12px;
}
</style>